import { render } from "./Welcome.vue?vue&type=template&id=839e5d88"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=839e5d88&lang=css"
script.render = render

export default script